import { CreatePanelRequest } from 'features/drilldown'
import { createContext, useContext } from 'react'

export interface DrilldownPanelCreationContextType {
  createPanels: (panelsToCreate: ReadonlyArray<CreatePanelRequest>) => void
}

const EMPTY_DRILLDOWN_PANEL_CREATION_CONTEXT: DrilldownPanelCreationContextType =
  {
    createPanels: () => {},
  }

export const DrilldownPanelCreationContext =
  createContext<DrilldownPanelCreationContextType>(
    EMPTY_DRILLDOWN_PANEL_CREATION_CONTEXT
  )

export function useDrilldownPanelCreation(): DrilldownPanelCreationContextType {
  const context = useContext(DrilldownPanelCreationContext)
  if (context === EMPTY_DRILLDOWN_PANEL_CREATION_CONTEXT) {
    throw new Error(
      'useDrilldownPanelCreation must be used within a DrilldownPanelCreationProvider'
    )
  }
  return context
}
